<template>
    <v-card>
        <v-card-title>
            404 ERROR
        </v-card-title>
        <v-card-subtitle>Page not found</v-card-subtitle>
        <v-card-text>This page is currently unavailable. Please check you are navigating to the page you want with the correct url. </v-card-text>
    </v-card>
</template>
<script>
export default ({
    name: "fourZeroFourPage",
    components: {

    },
    props: {

    },
    data: () => ({

    }),

})
</script>